import {
  ComponentRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseModalComponent } from '../components/base-modal/base-modal.component';
import { RRBaseModalComponent } from '../interfaces/modal-component';
import { RRModalModel } from '../models/modal.model';

@Directive({
  selector: '[rrModalConfirm]',
})
export class ModalConfirmDirective implements OnInit, OnDestroy {
  private componentRef: ComponentRef<RRBaseModalComponent>;
  private subscriptionButtons: Subscription;
  private subscriptionVisibility: Subscription;

  @Input() public rrModalConfirm: RRModalModel;
  @Output() public buttonClicked: EventEmitter<any> = new EventEmitter();

  constructor(private element: ElementRef, private viewRef: ViewContainerRef) {}

  ngOnInit() {
    this.componentRef =
      this.viewRef.createComponent<RRBaseModalComponent>(BaseModalComponent);
    const host = this.element.nativeElement;
    host.insertBefore(
      this.componentRef.location.nativeElement,
      host.firstChild,
    );
  }

  ngOnDestroy() {
    if (this.subscriptionButtons) {
      this.subscriptionButtons.unsubscribe();
    }
    if (this.subscriptionVisibility) {
      this.subscriptionVisibility.unsubscribe();
    }
  }

  @HostListener('click', ['$event'])
  public onClick(_event: MouseEvent): void {
    if (this.rrModalConfirm) {
      this.componentRef.instance.modalSettings = this.rrModalConfirm;
    }
    this.componentRef.instance.openModal();
    this.subscriptionVisibility =
      this.componentRef.instance.showModalChange.subscribe((isModalVisible) => {
        if (!isModalVisible) {
          this.ngOnDestroy();
        }
      });
    this.subscriptionButtons =
      this.componentRef.instance.clickedButton.subscribe((button) => {
        this.buttonClicked.emit(button);
      });
  }
}
